import React, {forwardRef, useImperativeHandle, useRef, useState} from "react";
import {Button, ConfigProvider, Dropdown, Flex, Input, Modal, Tree} from "antd";
import {CaretDownOutlined} from "@ant-design/icons";
import {FieldDataNode} from "rc-tree/lib/interface";
import {TreeProps} from "antd/es/tree";
import {generateRandomPageKey, getItem, MenuItem} from "../../utils";
import {IconAddBlack, IconDelete, IconFrame, IconMakeCopy, IconPageBlack, IconRename} from "../../Icon";
import {useTranslation} from "react-i18next";
import "./TreeListNode.css"
import {
    EVENT_CANVAS_DELETE_ELEMENT,
    EVENT_ELEMENT_DELETE, EVENT_FRAME_MAKE_COPY, EVENT_FRAME_PREVIEW_BY_ID,
    EVENT_UPDATE_FRAME_LIST,
    EVENT_UPDATE_FRAME_NAME
} from "@/Const";
import {postMessage} from "@/common/event";
import {APP_WEB} from "@/electron_interactive";
import DialogMessageBox from "@/common/DialogMessageBox";
const {DirectoryTree} = Tree;

type DataNode = FieldDataNode<{
    key:string;
    title?:string;
    editValue?:string;
    isEditable?:boolean;
    isFolder:boolean;
    drawJson:any;
    children?:any;
    icon:any;
    isSelected?:boolean;
    isHover?:boolean;
}>

let mSelectNode:any;
let mIsAddFolder:boolean = false;
let lastClickTime:any;
let mszMessageBoxAction:string;
let arrayMenuDataLastest:any=[];//最新的菜单。。。。
let mPendingElement;
let mPendingTreeNoteData;
let isMoreOpend:boolean = false;
let isMoreMenuClicked:boolean = false;
let mRootDiv:any = null;//drag的folder....
let mSelectFolder = null;
let mIsDefaultDragOk = false;
let mIsContextMenuClicked = false;
let mIsFullScreenDialog = false;

const TreeListFrame = forwardRef((props:{onItemClicked:any,onUpdateSort:any}, ref)=>{

    useImperativeHandle(ref,()=>({
        setFrameElementList:setFrameElementList,
        onIsFramePresent:onIsFramePresent,
        setOnIsPresentMode:setOnIsPresentMode
    }))
    const dialogMessageBoxRef = useRef(null);

    const [menuData,setMenuData] = useState<DataNode[]>([])
    const [treeSelectedKeys,setTreeSelectedKeys] = useState([]);
    const [treeDraggable,setTreeDraggable] = useState(true);
    const [isPresentMode, setIsPresentMode] = useState(APP_WEB?true:false);
    const [isFramePresent,setIsFramePresent] = useState(false);

    const {t} = useTranslation();
    const items: MenuItem[] = [
        getItem(t("Create copy"), 'copy', <IconMakeCopy/>, undefined,undefined,()=>{
            onMenuItemContextMenu("copy")
        }),
        getItem(t("Rename"), 'rename', <IconRename/>, undefined,undefined,()=>{
            onMenuItemContextMenu("rename")
        }),
        getItem(t("Delete"), 'delete', <IconDelete/>, undefined,undefined,()=>{
            onMenuItemContextMenu("delete")
        }),
    ];

    const onMenuItemContextMenu = (szAction:any)=>{
        mIsContextMenuClicked = true;

        mszMessageBoxAction = szAction;
        const data = [...menuData];
        if("copy" == szAction){
            // makeACopy(treeSelectedKeys[0]);
            postMessage(EVENT_FRAME_MAKE_COPY);
        }else if("rename" == szAction){
            loop(data, treeSelectedKeys[0], (item) => {
                item.isEditable = true;
                item.editValue = item.title;
            });
            setMenuData(data)
            setTreeDraggable(false);
        }else if("delete" == szAction) {
            // setIsMessageBoxShow(true);
            if (treeSelectedKeys.length == 0) return;
            let msg = t("Delete this Frame");
            // Modal.confirm({
            //     centered:true,
            //     content:msg,
            //     okText:t("Delete"),
            //     cancelText:t("Cancel"),
            //     onOk(){
            //         postMessage(EVENT_CANVAS_DELETE_ELEMENT,treeSelectedKeys[0]);
            //         setTimeout(()=>{
            //             postMessage(EVENT_UPDATE_FRAME_LIST);
            //         },50);
            //     }
            // })
            dialogMessageBoxRef.current?.onShowDialog(t("Tips"), msg, t("Delete"), () => {
                postMessage(EVENT_CANVAS_DELETE_ELEMENT, treeSelectedKeys[0]);
                setTimeout(() => {
                    postMessage(EVENT_UPDATE_FRAME_LIST);
                }, 50);
            })
        }

        setTimeout(()=>{
            mIsContextMenuClicked = false;
        },1000);

    }

    /**
     * 设置frame列表
     * @param arrayFrameElements
     */
    const setFrameElementList = (arrayFrameElements)=>{
        arrayFrameElements.sort((a:any,b:any)=>{
            return b.sort - a.sort;
        });
        var arrayDatas:any = [];
        arrayFrameElements.forEach(p=>{
            const itemNew = {
                title: p.name,
                editValue: p.name,
                key: p.id,
                icon: <IconFrame/>,
                isFolder: false,
                isEditable: false,
                element: p
            };
            arrayDatas.push(itemNew);
        })
        setMenuData(arrayDatas);
    }

    const onIsFramePresent = (isFramePresent:boolean)=>{
        setIsFramePresent(isFramePresent);
    }

    const setOnIsPresentMode = (isPresentMode:boolean)=>{
        setIsPresentMode(isPresentMode);
    }

    // 找到节点数据并回调处理节点方法 callback回调: node-当前节点 i-当前节点序号 data-包含当前节点的节点组 parentNode 当前节点父节点
    const loop = (
        data: DataNode[],
        key: React.Key,
        callback: (node: DataNode, i: number, data: DataNode[], parent?: DataNode) => void,
        parentNode?: DataNode,
    ) => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].key === key) {
                return callback(data[i], i, data, parentNode);
            }
            if (data[i].children) {
                loop(data[i].children!, key, callback, data[i]);
            }
        }
    };

    const loopRemove=(data,key)=>{
        for (var i=0;i<data.length;i++){
            var item = data[i];
            if (item.isFolder){
                for (var j=0;j<item.children.length;j++){
                    var subItem = item.children[j];
                    if (subItem.key === key){
                        item.children.splice(j,1);
                        return subItem;
                    }
                }
            }else{
                if (item.key === key){
                    data.splice(i,1);
                    return item;
                }
            }
        }
    }


    /**
     * tree选择.....
     */
    const onSelect:TreeProps["onSelect"] =((selectedKeys:any, info) => {
        // console.log(selectedKeys);
        // console.log(info)
        setTreeSelectedKeys(selectedKeys);
        if (isFramePresent){
            postMessage(EVENT_FRAME_PREVIEW_BY_ID, {id:selectedKeys[0]});
            return;
        }
        var now = new Date().getTime();
        if (now - lastClickTime < 300) {
            //双击
            const data = [...menuData];
            loop(data, selectedKeys[0], (item) => {
                item.isEditable = true;
                item.editValue = item.title;
            });
            setMenuData(data)
            setTreeDraggable(false);
        } else {
            props.onItemClicked(info.node.element);
        }
        lastClickTime = new Date().getTime();
    })

    const onDragOver = (info)=>{
        // console.log(info.node);
        mIsDefaultDragOk = false;

        if(mRootDiv != null){
            mRootDiv.style.border = '0px';
        }
        mSelectFolder = null;

        if(info.node.isFolder){
            mRootDiv = info.event.currentTarget;
            mRootDiv.style.border = '1px solid #0085FF';
            mSelectFolder = mRootDiv;
        }else{
            //根据ID找到父级
            loop(menuData,info.node.key,((node, i, data, parent) => {
                if(parent != undefined){
                    var div = document.getElementById(parent.key);
                    if(div != undefined){
                        mRootDiv = div.parentElement.parentElement.parentElement;
                        mRootDiv.style.border = '1px solid #0085FF';
                    }
                }
            }))
        }
    }

    const onDragEnd = (info)=>{
        if(mRootDiv != null){
            mRootDiv.style.border = '0px'
        }

        if (mSelectFolder != null && !mIsDefaultDragOk){
            let szMoveKey = info.node.key;
            if (info.dragNode != undefined){
                szMoveKey = info.dragNode.key;
            }
            var arrayDivs = mSelectFolder.getElementsByClassName("custom-element");
            if (arrayDivs.length > 0){
                setTimeout(()=>{
                    var szDestKey = arrayDivs[0].id;
                    var arrayNew = [...menuData];
                    for (var i=0;i<arrayNew.length;i++){
                        var item = arrayNew[i];
                        if (item.key === szDestKey && item.isFolder){
                            //移动到的父级....
                            //从原来的里面删除
                            var newNode = loopRemove(arrayNew,szMoveKey);
                            item.children.push(newNode);
                            setMenuData(arrayNew);
                            break;
                        }
                    }
                },50);
            }
        }

        //重置排序
        var arrayNew = [...menuData];
        for (let i=0;i<arrayNew.length;i++){
            arrayNew[i].element.sort = (arrayNew.length - i);
        }
        setMenuData(arrayNew);
        props.onUpdateSort(arrayNew);
    }

    const onDrop: TreeProps['onDrop'] = (info) => {
        console.log(info);
        // onDragEnd(info);
        if(mRootDiv != null){
            mRootDiv.style.border = '0px'
        }

        var isDragOk = true;
        const dropKey = info.node.key;
        const dragKey = info.dragNode.key;
        const dropPos = info.node.pos.split('-');
        const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
        // const loop = (
        //     data: DataNode[],
        //     key: React.Key,
        //     callback: (node: DataNode, i: number, data: DataNode[]) => void,
        // ) => {
        //     for (let i = 0; i < data.length; i++) {
        //         if (data[i].key === key) {
        //             return callback(data[i], i, data);
        //         }
        //         if (data[i].children) {
        //             loop(data[i].children!, key, callback);
        //         }
        //     }
        // };
        const data = [...menuData];

        // Find dragObject
        let dragObj: DataNode;
        loop(data, dragKey, (item, index, arr) => {
            arr.splice(index, 1);
            dragObj = item;
        });

        mIsDefaultDragOk = false;

        if (!info.dropToGap) {
            // Drop on the content
            loop(data, dropKey, (item) => {
                if(item.children == null){//不能移到画布下。。。。
                    //插入到当前下...
                    var nCurIndex = data.indexOf(item);
                    data.splice(nCurIndex+1,0,info.dragNode as DataNode);
                    isDragOk = true;
                }else{
                    if (info.dragNode.isFolder && item.isFolder){
                        isDragOk = false;
                    }else{
                        item.children = item.children || [];
                        // where to insert. New item was inserted to the start of the array in this example, but can be anywhere
                        item.children.unshift(dragObj);
                    }
                }
            });
            mIsDefaultDragOk = true;
        } else if (
            ((info.node as any).props.children || []).length > 0 && // Has children
            (info.node as any).props.expanded && // Is expanded
            dropPosition === 1 // On the bottom gap
        ) {
            loop(data, dropKey, (item,num,data) => {
                if(item.children == null) {//不能移到画布下。。。。
                    isDragOk = false;
                }else{
                    if (info.dragNode.isFolder && item.isFolder){
                        isDragOk = false;
                    }else{
                        item.children = item.children || [];
                        // where to insert. New item was inserted to the start of the array in this example, but can be anywhere
                        item.children.unshift(dragObj);
                        // in previous version, we use item.children.push(dragObj) to insert the
                        // item to the tail of the children
                    }
                }
            });
        } else {
            let ar: DataNode[] = [];
            let i: number;
            loop(data, dropKey, (_item, index, arr,parent) => {
                if ((info.dragNode.isFolder && (_item.isFolder || parent?.isFolder))){
                    isDragOk = false;
                }else{
                    ar = arr;
                    i = index;
                }
            });
            if (dropPosition === -1) {
                ar.splice(i!, 0, dragObj!);
            } else {
                ar.splice(i! + 1, 0, dragObj!);
            }
        }
        if(isDragOk){
            setMenuData(data);
        }

        if (menuData.length != data.length){
            mIsDefaultDragOk = true;
        }
    };

    // input 改变
    const onChange = (e:any, key:any) => {
        const data = [...menuData];
        loop(data, key, (item) => {
            item.editValue = e.target.value;
            item.title = item.editValue;
        });
        setMenuData(data);

    };

    //丢失焦点
    const onBlur = (e:any,key:any)=>{
        const data = [...menuData];
        var treeItem = undefined;
        loop(data, key, (item) => {
            item.editValue = e.target.value;
            item.title = item.editValue;
            item.isEditable = false;
            treeItem = item;
            // postMessage(POST_MESSAGE_RENAME_SUB_NOTENAME,{key:item.key,name:item.title});
            //更新元素的名称
            postMessage(EVENT_UPDATE_FRAME_NAME,{element:item.element,name:item.title})
        });
        setMenuData(data)
        setTreeDraggable(true);
    }

    const onCanvasKeyPress = (e,key)=>{
        if (e.charCode == 13){
            e.currentTarget.blur();
        }
    }

    return(
        <>
            <Flex gap={"middle"} vertical style={{height:'100%',width:'100%'}}>
                <Flex align="center" className="left-menu-title mt-6" style={{visibility:isPresentMode?'hidden':'visible'}}>
                    <span  className='ml-4 font-family-medium font-size-12' style={{color:isPresentMode?"white":"var(--text-color)"}}>{t("Frames")}</span>
                    <div style={{flexGrow:1}}></div>
                    {/*<Button type="text" shape="circle" icon={<FolderOutlined rev={undefined}/>} onClick={onAddFolder}/>*/}
                    {/*<Button type="text" shape="circle" icon={<IconAddBlack/>} onClick={onAddItem}/>*/}
                </Flex>
                <div className='hovered-overflow-y-auto' style={{overflowX:'hidden', marginTop: isPresentMode?'-36px':'-12px'}}>
                    <ConfigProvider
                        theme={{
                            components: {
                                Tree: {
                                    colorPrimary: isPresentMode?"#212121":'var(--tree-item-select-color)'
                                }
                            }
                        }}
                    >
                        <DirectoryTree
                            className="tree-fuck-css-left-align"
                            switcherIcon={<CaretDownOutlined style={{color: 'black', paddingTop: '6px'}} rev={undefined}/>}
                            onSelect={onSelect}
                            treeData={menuData}
                            selectedKeys={treeSelectedKeys}
                            onRightClick={(info, node) => {
                                setTreeSelectedKeys([info.node.key as string])
                            }}
                            showIcon={!isPresentMode}
                            blockNode={true}
                            draggable={treeDraggable}
                            onDragOver={onDragOver}
                            onDragEnd={onDragEnd}
                            onDrop={onDrop}
                            // onMouseEnter={onTreeMouseEnter}
                            // onMouseLeave={onTreeMouseLeave}
                            titleRender={(nodeData: DataNode) => {
                                if (nodeData.isEditable && !APP_WEB) {
                                    return (
                                        <div style={{display: "flex",width: "196px", alignItems: "center"}}>
                                            <Input className='default-font-size font-family-regular'
                                                   value={nodeData.editValue || ''}
                                                   style={{
                                                       color: "var(--text-color)",
                                                       marginLeft: '0px',
                                                       paddingLeft: '0px',
                                                       marginBottom: '0px',
                                                       marginTop:'1px',
                                                       paddingRight:'8px',
                                                   }}
                                                   variant={"borderless"}
                                                   autoFocus={true}
                                                   onKeyPress={(e) => onCanvasKeyPress(e, nodeData.key)}
                                                   onChange={(e) => onChange(e, nodeData.key)}
                                                   onBlur={(e) => onBlur(e, nodeData.key)}
                                            />
                                            {/*<div style={{width: '16px', height: '16px', marginLeft: '16px'}}></div>*/}
                                        </div>
                                    )
                                } else {
                                    return (
                                        <Dropdown overlayClassName='default-dropdown-style' menu={{items}}
                                                  trigger={['contextMenu']} overlayStyle={{width: 'auto'}}
                                                  onOpenChange={(open) => {
                                                      isMoreOpend = open;
                                                  }}>
                                            <div className='custom-element' id={nodeData.key}
                                                 style={{display: "flex", width: "196px", alignItems: "center"}}>
                                                <Input className='default-font-size font-family-regular'
                                                       readOnly={true} bordered={false}
                                                       style={{
                                                           color: isPresentMode?"white":"var(--text-color)",
                                                           marginLeft: '0px',
                                                           paddingLeft: '0px',
                                                           cursor: "pointer",
                                                           marginBottom: '0px',
                                                           marginTop:'1px',
                                                       }}
                                                       value={nodeData.title}/>
                                            </div>
                                        </Dropdown>
                                    )
                                }
                            }}
                        />
                    </ConfigProvider>
                </div>
            </Flex>
            <DialogMessageBox ref={dialogMessageBoxRef}/>
        </>
    )
})

export default TreeListFrame;